import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from '../../../core/logger/global-logger.service';
import { SubheaderHandlerService } from '../../../shared/services/subheader-handler.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'dsi-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  translatedText = [];

  constructor(private modalService: NgbModal,
    private router: Router,
    private logger: LoggerService,
    private translate: TranslateService,
    private subHeaderService: SubheaderHandlerService) {
    router = this.router;
    translate.get([
      'DSI_HELP.HOME_TITLE',
      'DSI_HELP.HOME_CONTENT_FIRST',
      'DSI_HELP.HOME_CONTENT_SECOND',
      'DSI_HELP.EVALUATOR_CONTENT_FIRST',
      'DSI_HELP.EVALUATOR_CONTENT_SECOND'
    ]).subscribe((translations: string) => {
      this.translatedText[0] = translations['DSI_HELP.HOME_TITLE'];
      this.translatedText[1] = translations['DSI_HELP.HOME_CONTENT_FIRST'];
      this.translatedText[2] = translations['DSI_HELP.HOME_CONTENT_SECOND'];
      this.translatedText[3] = translations['DSI_HELP.EVALUATOR_TITLE'];
      this.translatedText[4] = translations['DSI_HELP.EVALUATOR_CONTENT_FIRST'];
      this.translatedText[5] = translations['DSI_HELP.EVALUATOR_CONTENT_SECOND'];
    });
  }
  openHelpModal(content) {
    this.modalService.open(content, { windowClass: 'help-modal' });
  }

  ngOnInit() {
    this.router = this.router;

  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/shared/help/help.component.ts